import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Worker, Viewer } from "@react-pdf-viewer/core";
// import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import {
  downloadCateloguePdf,
  downloadCateloguePdfForSeller,
  getCatalogueViewPdf,
} from "../../../../../redux/action/catalogue";

const CatalogueViewPdf = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const { accountType } = useSelector((state) => state.account);
  const { CateloguePdfUrl, catelogueViewPdfLoading, PdfLoading } = useSelector(
    (state) => state.catelogueViewPdf
  );

  // const defaultLayoutPluginInstance = defaultLayoutPlugin();

  useEffect(() => {
    dispatch(getCatalogueViewPdf(id, accountType));
  }, [dispatch, id, accountType]);

  useEffect(() => {
    if (CateloguePdfUrl) {
      setError(null);
    }
  }, [CateloguePdfUrl]);

  if (catelogueViewPdfLoading) {
    return <div>Loading PDF...</div>;
  }

  if (error) {
    return <div>Error loading PDF: {error}</div>;
  }

  return (
    <div className="flex column">
      <div className="valign-wrapper space-between">
        <span className="valign-wrapper gap-1">
          <span
            className="material-icons-outlined pointer"
            onClick={() => navigate(-1)}
          >
            arrow_back
          </span>
          <h4>View Catalogue</h4>
        </span>

        <button
          className={`button-style pointer cercle-purple white-text font-weight-600 font-18px font-cercular-bold`}
          style={{
            padding: "5px 30px",
          }}
          onClick={() => {
            accountType === "industry" ? dispatch(downloadCateloguePdfForSeller(id)) : dispatch(downloadCateloguePdf(id))
          }}
          disabled={PdfLoading}
        >
          {PdfLoading ? "Downloading ...." : "Download"}
        </button>
      </div>
      <div className="flex justify-center pin-top">
        {CateloguePdfUrl ? (
          <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
            <div className="pin-top" style={{ width: "950px" }}>
              <Viewer
                fileUrl={CateloguePdfUrl}
                plugins={[]}
                onError={(e) => setError(e.message)}
              />
              {/* <div
                className="grey lighten-3 select-label"
                style={{
                  top: "1.6px",
                  zIndex: 999,
                  height: "36px",
                  width: "120px",
                  right: "2%",
                }}
              ></div> */}
            </div>
          </Worker>
        ) : (
          <div>No PDF to display</div>
        )}
      </div>
    </div>
  );
};

export default CatalogueViewPdf;
